/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { useEffect, useState } from "react";
import { dxStreamStart, streamDataToDx, dxStreamEnd } from "api/DxAPI";
import { trackLiquidModeViewGenerationStart, trackLiquidModeViewGenerationEnd } from "analytics/events";
import docAPI from "api";
import StreamReaderAdapter from "./StreamReaderAdapter";

const useStreamReaderAdapter = () => {
  const [streamReader, setStreamReader] = useState(null);

  useEffect(() => {
    if (!streamReader) {
      docAPI
        .translateToLiquidModeView()
        .then(response => {
          const { data } = response;
          if (data) {
            const { htmlStream } = data;
            const htmlStreamReader = htmlStream.getReader();
            const ftpdfWebViewStreamReader = new StreamReaderAdapter(htmlStreamReader);
            setStreamReader(ftpdfWebViewStreamReader);
          }
        })
        .catch(e => {
          console.error(`Error in translateToLiquidModeView - ${e}`);
        });
    }
  }, []);

  return { streamReader };
};

const FTPDFWebViewStreamReader = props => {
  const { liquidModeViewReady, liquidModeViewLoadedCallback, liquidModeViewErrorCallback } = props;
  const { streamReader } = useStreamReaderAdapter();

  useEffect(() => {
    if (liquidModeViewReady && streamReader) {
      trackLiquidModeViewGenerationStart();
      dxStreamStart()
        .then(_ => {
          streamDataToDx(streamReader)
            .then(_ => {
              dxStreamEnd().then(() => {
                liquidModeViewLoadedCallback();
              });
              trackLiquidModeViewGenerationEnd();
            })
            .catch(e => {
              liquidModeViewErrorCallback(e);
            });
        })
        .catch(e => {
          console.error(`Error in dxStreamStart - ${e}`);
        });
    }
  }, [liquidModeViewReady, streamReader]);

  return null;
};

export default FTPDFWebViewStreamReader;
